angular.module('assets')
    .controller('AssetDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, Asset) {
        this.$onInit = () => {
            this.item = data
        };
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = Asset.update(this.item).$promise
            } else {
                promise = Asset.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('asset.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        };
    })
